__turbopack_context__.v({
  "socialIcon": "SocialLink-module__FsPDXq__socialIcon",
});
